/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Step_Instructions_DescriptionInputs */



/**
* | output |
* | --- |
* | "The agent's role in your own words. The settings on this page are added automatically." |
*
* @param {Agent_Builder_Step_Instructions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_step_instructions_description = /** @type {((inputs?: Agent_Builder_Step_Instructions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Step_Instructions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Rolle des Agenten in Ihren eigenen Worten. Die Einstellungen auf dieser Seite werden automatisch ergänzt.")
	return /** @type {LocalizedString} */ ("The agent's role in your own words. The settings on this page are added automatically.")
});